import { MediumHeader } from '@narvar/nth-bit-header';
import React, { FC } from 'react';
import { useTranslator } from '../utils/translator';

const InitialPanel: FC = () => {
  const { t } = useTranslator();

  const scheduleDeliveryPromptHeader = t(
    'It’s time to schedule your delivery. Please schedule an appointment here.',
  );

  return <MediumHeader as="h2">{scheduleDeliveryPromptHeader}</MediumHeader>;
};

export default InitialPanel;
